import { Mockup } from "./Mockup";

export default Mockup;
